// Startet Zeichen-Animationen, sobald ein Element sichtbar wird –
// und erneut bei jedem weiteren Erscheinen.
(() => {
  const SELEKTOR = '.wanu-zeichnen, .wanu-zeichnen-strich';
  const AKTIV = 'wanu-zeichnen--laeuft';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const beobachter = new IntersectionObserver(
    (eintraege) => {
      eintraege.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.remove(AKTIV);
          // Neustart der Animation erzwingen
          void e.target.offsetWidth;
          e.target.classList.add(AKTIV);
        } else {
          e.target.classList.remove(AKTIV);
        }
      });
    },
    { threshold: 0.25 }
  );

  const beobachten = (wurzel = document) =>
    wurzel.querySelectorAll(SELEKTOR).forEach((el) => beobachter.observe(el));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => beobachten());
  } else {
    beobachten();
  }

  // Nachgeladene Abschnitte (Theme-Editor) ebenfalls erfassen
  document.addEventListener('shopify:section:load', (e) => beobachten(e.target));
})();

// Schwebende Icons: Versatz und Drehung folgen der Scrollposition.
// Der Abschnitt gibt den Bezug – steht er in der Mitte des Fensters, ist
// der Versatz null; darueber und darunter waechst er in die jeweilige
// Richtung. Die weiche Bewegung besorgt die CSS-Transition.
(() => {
  const BEHAELTER = '.wanu-schwebe-icons';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const behaelter = () =>
    [...document.querySelectorAll(BEHAELTER)].filter((el) => {
      const art = el.dataset.bewegung;
      return art === 'beides' || art === 'scrollen';
    });

  let angefordert = false;

  const zeichnen = () => {
    angefordert = false;
    const fensterhoehe = window.innerHeight;

    behaelter().forEach((el) => {
      const rahmen = el.getBoundingClientRect();
      if (rahmen.bottom < 0 || rahmen.top > fensterhoehe) return;

      // -1 (Abschnitt verlaesst das Fenster oben) bis +1 (kommt von unten)
      const mitte = rahmen.top + rahmen.height / 2;
      const anteil = (mitte - fensterhoehe / 2) / fensterhoehe;

      // Federmodell statt einfacher Annaeherung: Die Grafik hat eine
      // Geschwindigkeit, die sich erst aufbauen muss. Dadurch laeuft sie
      // sanft an, geht in der Mitte voll mit und klingt weich aus – eine
      // reine Annaeherung wuerde dagegen sofort losspringen.
      const traegheit = Number(el.dataset.traegheit || 4);
      const federkraft = 0.09 / Math.max(traegheit, 1);
      const reibung = 0.82;

      el.querySelectorAll('.wanu-schwebe-icon').forEach((icon) => {
        // Tempo und Drehung stehen je Grafik im Markup – so laesst sich
        // jede einzeln abstimmen, statt alle im Gleichschritt zu bewegen.
        const tempo = Number(icon.dataset.tempo || 0);
        const grad = Number(icon.dataset.drehung || 0);
        const zielWeg = anteil * tempo * 800;
        const zielDrehung = anteil * grad;

        const istWeg = Number(icon.dataset.istWeg || 0);
        const istDrehung = Number(icon.dataset.istDrehung || 0);
        let tempoWeg = Number(icon.dataset.tempoWeg || 0);
        let tempoDrehung = Number(icon.dataset.tempoDrehung || 0);

        tempoWeg = (tempoWeg + (zielWeg - istWeg) * federkraft) * reibung;
        tempoDrehung =
          (tempoDrehung + (zielDrehung - istDrehung) * federkraft) * reibung;

        const neuWeg = istWeg + tempoWeg;
        const neuDrehung = istDrehung + tempoDrehung;

        icon.dataset.istWeg = neuWeg;
        icon.dataset.istDrehung = neuDrehung;
        icon.dataset.tempoWeg = tempoWeg;
        icon.dataset.tempoDrehung = tempoDrehung;
        icon.style.setProperty('--wanu-schwebe-scroll', `${neuWeg.toFixed(2)}px`);
        icon.style.setProperty(
          '--wanu-schwebe-drehung',
          `${neuDrehung.toFixed(2)}deg`
        );
      });
    });
  };

  const anfordern = () => {
    if (angefordert) return;
    angefordert = true;
    requestAnimationFrame(zeichnen);
  };

  // capture: true faengt auch Scrollereignisse aus Unterelementen ab –
  // im Theme-Editor scrollt nicht das Fenster, sondern ein Container, und
  // Scroll-Ereignisse steigen nicht von selbst nach oben.
  window.addEventListener('scroll', anfordern, { passive: true, capture: true });
  window.addEventListener('resize', anfordern, { passive: true });
  document.addEventListener('shopify:section:load', anfordern);

  // Zusaetzliche Absicherung: Solange ein Behaelter im Blickfeld ist, wird
  // ohnehin Bild fuer Bild nachgerechnet. Das deckt Umgebungen ab, in denen
  // gar keine Scrollereignisse ankommen – etwa sanftes Scrollen per Skript.
  let laeuft = false;

  const schleife = () => {
    if (!laeuft) return;
    zeichnen();
    requestAnimationFrame(schleife);
  };

  if ('IntersectionObserver' in window) {
    const waechter = new IntersectionObserver(
      (eintraege) => {
        const sichtbar = eintraege.some((e) => e.isIntersecting);
        if (sichtbar && !laeuft) {
          laeuft = true;
          requestAnimationFrame(schleife);
        } else if (!sichtbar) {
          laeuft = [...document.querySelectorAll(BEHAELTER)].some((el) => {
            const r = el.getBoundingClientRect();
            return r.bottom > 0 && r.top < window.innerHeight;
          });
        }
      },
      { threshold: 0 }
    );

    const beobachten = () =>
      document.querySelectorAll(BEHAELTER).forEach((el) => waechter.observe(el));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', beobachten);
    } else {
      beobachten();
    }
    document.addEventListener('shopify:section:load', beobachten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anfordern);
  } else {
    anfordern();
  }
})();
